import WithRoutePermission from "shared/components/HOC/WithRoutePermission";
import { MODULES, SCREENS, SUBMODULES } from "utils/constants";
import Create from "./Create";
import List from "./List";

const routes = [
  {
    path: SCREENS.PRIVATE.BROKER.REMINDERS.LIST.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.REMINDER]: SUBMODULES.BROKER_LIST }}
        WrappedComponent={List}
      />
    ),
  },
  {
    path: SCREENS.PRIVATE.BROKER.REMINDERS.CREATE.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.REMINDER]: SUBMODULES.BROKER_CREATE }}
        WrappedComponent={Create}
      />
    ),
  },
];

export default routes;
